import { guardUnspecified } from '@smh/utils/guards';

import { getResponsiveImageData } from '@jtnews/shared/images';

import type {
  PersonalSelectionItemDTO,
  PersonalSelectionLazyBlockDTO
} from './personal-selection.dto';
import { DataBlockMetaDTO } from './personal-selection.dto';
import type {
  PersonalSelectionBlock,
  PersonalSelectionItemVM
} from './personal-selection.vm';

const presentImage = (imageDTO: PersonalSelectionItemDTO['mainPhoto']) => {
  const defaultImg = {
    src: '',
    sources: [],
    hasCommercialLabel: false
  };
  const values = [
    {
      breakpoint: 375,
      width: 342
    },
    {
      breakpoint: 600,
      width: 566
    },
    {
      breakpoint: 899,
      width: 382
    },
    {
      breakpoint: 1279,
      width: 440
    },
    {
      breakpoint: 0,
      width: 316,
      noMedia: true
    }
  ];

  if (!guardUnspecified(imageDTO)) {
    return defaultImg;
  }

  const image = getResponsiveImageData({
    url: imageDTO.url,
    hasCommercialLabel: imageDTO.hasCommercialLabel,
    width: imageDTO.width,
    values
  });

  return guardUnspecified(image)
    ? {
        src: image.data.img.src,
        sources: image.data.sources,
        loading: image.data.img.loading,
        decoding: image.data.img.decoding,
        hasCommercialLabel: image.data.hasCommercialLabel
      }
    : defaultImg;
};

const presentPersonalSelectionItem = (
  itemDTO: PersonalSelectionItemDTO,
  meta: DataBlockMetaDTO
): PersonalSelectionItemVM => ({
  id: itemDTO.id,
  header: itemDTO.header,
  url: itemDTO.urls.url,
  image: presentImage(itemDTO.mainPhoto),
  type: itemDTO.isCommercial ? 'Рекламный' : 'Редакционный',
  selectionType: meta.mlRecords.includes(itemDTO.id) ? 'ml' : 'newsfeed'
});

export const presentPersonalSelectionBlock = (
  block: PersonalSelectionLazyBlockDTO,
  isMobile: boolean
): PersonalSelectionBlock => {
  const { data, type, meta } = block;
  const mobileCount = 2;
  const desktopCount = 3;
  const countItems = isMobile ? mobileCount : desktopCount;

  const trimmed = data?.slice(0, countItems);

  return {
    data: guardUnspecified(trimmed)
      ? trimmed.map(item => presentPersonalSelectionItem(item, meta))
      : [],
    type,
    isLazy: false,
    params: null,
    meta: null
  };
};
